import { ReactElement } from 'react';
import { Box, SimpleGrid, Icon, Stack, Flex, useColorModeValue, Container, Heading, Text } from '@chakra-ui/react';
import { FaTwitter, FaTelegramPlane, FaDiscord, FaMedium } from 'react-icons/fa';

interface SocialIconProps {
  icon: ReactElement;
  href: string;
}

const SocialIcon = ( { icon, href }: SocialIconProps ) => {
  return (
    <a href={href}>
      <Flex
        w={16}
        h={16}
        align={'center'}
        justify={'center'}
        color={'black'}
        rounded={'full'}
        bg={'yellow.300'}
        mb={1}>
        {icon}
      </Flex>
    </a>
  );
}

export default function FourColumnCards() {
  return (
    <>
      <Box bg={useColorModeValue('yellow.100', 'yellow.900')} p={4} px={100} pb={90}>
          <Stack spacing={4} as={Container} maxW={'3xl'} textAlign={'center'} py='50'>
            <Heading fontSize={'5xl'} color='black'>Community</Heading>
            <Text color={'gray.600'} fontSize={'2xl'}>
              Join the Crangon Community to stay connected, make friends and share feedbacks!
            </Text>
          </Stack>
          <Box>
            <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={10} px='200' justifyItems={'center'}>
            <Box>
                <SocialIcon
                  icon={<Icon as={FaTwitter} w={10} h={10} />}
                  href={'#'}
                />
              </Box>

              <Box>
                <SocialIcon
                  icon={<Icon as={FaTelegramPlane} w={10} h={10} />}
                  href={'#'}
                />
              </Box>

              <Box>
              <SocialIcon
                icon={<Icon as={FaDiscord} w={10} h={10} />}
                href={'#'}
              />
              </Box>

              <Box>
              <SocialIcon
                icon={<Icon as={FaMedium} w={10} h={10} />}
                href={'#'}
              />
              </Box>
            </SimpleGrid>
          </Box>
      </Box>
    </>
  );
}
